import { ForwardRefComponent, HTMLMotionProps, motion } from "framer-motion";
import { ComponentProps, ReactNode } from "react";

type AccordionAnimationProps = {
  children?: ReactNode;
  duration?: number;
} & ComponentProps<ForwardRefComponent<HTMLDivElement, HTMLMotionProps<"div">>>;

export const AccordionAnimation = ({
  children,
  duration = 0.4,
  ...props
}: AccordionAnimationProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: "auto" }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration, ease: "easeInOut" }}
      {...props}
    >
      {children}
    </motion.div>
  );
};
